module.exports = __webpack_public_path__ + "img/360.48d05cb7.jpg";